import { AnalysisGroup } from 'app/providers/storage-api/analysis-group-service';
import { Project } from 'app/providers/storage-api/project.service';
import { ObjectLabel } from '../../../providers/storage-api/object-label.service';
import { ProjectItem } from '../services/project-detail.service';
import { mapObjectLabelsToProjectItemLabels } from './common.model';

export class ProjectAnalysisGroup {
  static createGroupItem(group: AnalysisGroup, project: Project): ProjectItem {
    const displayData = {
      docCount: this.getDocumentCount(group),
      analysisCount: group.analyses.length,
      activeUse: [],
    };

    group.analyses = project.analyses.filter((pa) =>
      // For some reason we have this duality of keynames, and i cannot find out where it originates (ga.name vs ga.analysisName)
      group.analyses.some((ga) => ga.name === pa.name || ga.analysisName === pa.name)
    );

    return {
      type: 'group',
      id: group.id,
      name: group.name,
      modified: new Date(group.modifiedAt),
      created: new Date(group.createdAt),
      labels: this.createAnalysisGroupLabels(group),
      group,
      displayData,
    };
  }

  static getDocumentCount(group: AnalysisGroup): number {
    return group.analyses.reduce((count, analysis) => count + analysis.documentCount, 0);
  }

  static createAnalysisGroupLabels(group: AnalysisGroup) {
    return mapObjectLabelsToProjectItemLabels(group.objectLabels as ObjectLabel[]);
  }
}
